import { UbudStorageModule } from '@ubud/storage';
import { NgModule } from '@angular/core';
import { InstitutionService } from '@lemsar/institution/domains/services/institution.service';
import { ProgramService } from '@lemsar/institution/domains/services/program.service';
import { TrainingService } from '@lemsar/institution/domains/services/training.service';
import { BuildingService } from '@lemsar/institution/domains/services/building.service';
import { EmployeeService } from '@lemsar/institution/domains/services/employee.service';
import { EquipmentBuildingService } from '@lemsar/institution/domains/services/equipment-building.service';
import { EquipmentService } from '@lemsar/institution/domains/services/equipment.service';
import { EquipmentInstitutionService } from '@lemsar/institution/domains/services/equipment-institution.service';
import { InstructorService } from './services/instructor.service';
import { InstitutionHistoryService } from '@lemsar/institution/domains/services/institution-history.service';
import { DocumentService } from '@lemsar/institution/domains/services/document.service';
import { JkpInstitutionService } from '@lemsar/institution/domains/services/jkp-institution.service';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    11/06/2018
 */
@NgModule({
    imports: [UbudStorageModule],
    providers: [
        InstitutionService,
        ProgramService,
        TrainingService,
        BuildingService,
        EmployeeService,
        EquipmentBuildingService,
        EquipmentService,
        EquipmentInstitutionService,
        InstructorService,
        InstitutionHistoryService,
        DocumentService,
        JkpInstitutionService,
    ],
})
export class LemsarInstitutionDomainModule {}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/module.ts